import { render, staticRenderFns } from "./RecommendedListAdd.vue?vue&type=template&id=3e26bd9b&scoped=true&"
import script from "./RecommendedListAdd.vue?vue&type=script&lang=js&"
export * from "./RecommendedListAdd.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedListAdd.vue?vue&type=style&index=0&id=3e26bd9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e26bd9b",
  null
  
)

export default component.exports